import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Add, Refresh } from '@mui/icons-material';
import { Box, Button, Divider, Typography } from '@mui/material';

import StatusButton from '../components/common/StatusButton';
import PrimaryLayout from '../components/layout/PrimaryLayout';
import DataTable from '../components/tables/DataTable';
import { Column } from '../components/tables/interfaces';
import { axiosRepoIntance } from '../services/api-client';
import { Branch, CommitStatus } from '../services/repo-service';
import { OWNER, Repo_Type } from '../utils/constants/gitea';


const Flows: React.FC = () => {

  const navigate = useNavigate();

  const [flag, setFlag] = useState(false);

  const columns: Column[] = [
    { id: "name", label: "Name", type: 'string' },
    {
      id: "id",
      label: "Commit ID",
      type: 'string',
      onCellClick: (value, row) => navigate(`/flows/${row.name}/${row.id}`)
    },
    {
      id: "status",
      label: "Status",
      type: "string",
    },
    { id: "message", label: "Commit Message", type: "string" },
    { id: "author", label: "Author", type: "string" },
    { id: "created_at", label: "Created At", type: "datetime" },
  ];

  const deploymentStatusMap: Record<string, any> = {};

  const fetchData = async (query?: { pageSize?: number; nextPageToken?: string } | { page?: number; limit?: number }) => {
    if (query && ('page' in query || 'limit' in query)) {
      try {
        const response = await axiosRepoIntance.repos.repoListBranches(OWNER, Repo_Type.flows, query);
        console.log(response.data);
        const branches = response.data;

        await Promise.all(
          branches.map(async (branch) => {
            let temp: CommitStatus[] = [];
            let deploymentStatus = "No Commits Found";
            if (branch.commit?.id) {
              try {
                temp = await fetchRunnerStatus(
                  branch.commit.id,
                  Repo_Type.flows
                );
                const status = temp.length > 0 ? temp[0].status : undefined;
                const des = temp.length > 0 ? temp[0].description : "";
                deploymentStatus = status || "No Commits Found";
                if (deploymentStatus === "pending") {
                  setFlag(true);
                }
                if (deploymentStatus === "success" && des === "Has been skipped") {
                  deploymentStatus = "failure"
                }
              } catch (error) {
                console.error("Error fetching runner status:", error);
              }
              deploymentStatusMap[branch.commit.id] = (
                temp.length > 0 ? <StatusButton
                  deploymentStatus={deploymentStatus}
                  context={temp[0].context ? temp[0].context : ""}
                  createdAt={temp[0].created_at ? temp[0].created_at : ""}
                  updatedAt={temp[0].updated_at ? temp[0].updated_at : ""}
                /> :
                  <Typography variant="body2" color="textSecondary">
                    No Status available, Please refresh.
                  </Typography>
              );
            }
          })
        );

        return branches;
      } catch (error) {
        console.error('Error fetching blocks:', error);
        return [] as Branch[];
      }
    }
    else {
      return [] as Branch[];
    }
  };

  const dataExtractor = (response: Branch[]): any[] => {
    return (response || []).map(branch => ({
      id: branch.commit?.id,
      name: branch.name,
      status: deploymentStatusMap[branch.commit?.id || ''],
      author: branch.commit?.author?.name,
      message: branch.commit?.message,
      created_at: branch.commit?.timestamp,
    }));
  };

  const fetchRunnerStatus = async (
    commit_id: string,
    branch_name: string,
    query?: {
      sort?: "oldest" | "recentupdate" | "leastupdate" | "leastindex" | "highestindex";
      page?: number;
      limit?: number;
    }
  ) => {
    try {
      const response = await axiosRepoIntance.repos.repoListStatusesByRef(
        OWNER,
        branch_name,
        commit_id,
        {
          sort: query?.sort || "leastindex",
          page: query?.page || 1,
          limit: query?.limit || 1,
        }
      );
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching runner statuses:", error);
      return [];
    }
  };

  useEffect(() => {
    const getData = async () => {
      const result = await fetchData();
    };
    getData();
  }, [flag]);

  return (
    <PrimaryLayout>
      <Box sx={{ mx: 2, my: 1 }}>
        <Typography variant="h4" sx={{ mb: 1 }}>
          Flows
        </Typography>
        <Typography variant="body1" color="text.secondary">
          This is your workflow design studio — view all saved workflows and manage their versions.
          Use the “Add Flow” button to create new workflows using an intuitive drag-and-drop interface.
        </Typography>
      </Box>

      <Box display="flex" gap={2} sx={{ m: 2 }}>
        <Button
          variant="contained"
          color='secondary'
          startIcon={<Refresh />}
          onClick={() => setFlag(!flag)}
        >
          Refresh
        </Button>

        <Button color='primary' variant="contained" startIcon={<Add />} onClick={() => navigate("add")} sx={{ mr: 2 }}>
          Add Flow
        </Button>
      </Box>
      <Box>
        <DataTable
          columns={columns}
          fetchData={fetchData}
          dataExtractor={dataExtractor}
          stickyHeader
          tableContainerMaxHeight={'calc(100vh - 190px)'}
        />
      </Box>

      {/* <Container sx={{ maxWidth: '100% !important' }}>
            </Container> */}
    </PrimaryLayout>
  )
}

export default Flows